module.exports = __webpack_public_path__ + "static/austravel-ab5f13ce2b584601aad6c8faa7c7e367.jpg";